<template>
  <v-toolbar-title :class="{ 'dashboard-toolbar-title': isDashboard }">
    <div v-if="isDashboard" class="dashboard-greeting">
      <strong>Hello, {{ displayName }} <span aria-hidden="true">👋</span></strong>
      <small>Welcome back to your trading dashboard</small>
    </div>
    <template v-else>
      <v-icon :color="$vuetify.theme.dark ? '#647E98' : '#171717'">
        mdi-view-dashboard
      </v-icon>
      <span class="ml-4">{{ currentPageTitle === 'Manage Investors Account Details' ? 'My Manager Account Details' : currentPageTitle === 'Bank Information' ? 'Wallet Information' : currentPageTitle === "Terms And Condition" ? "Terms & Conditions" : currentPageTitle === "Create Investor Account Auth" ? "Create Investor Account" : currentPageTitle === "Profile Verify" ? "Profile & Verification" : currentPageTitle }}</span>
    </template>
  </v-toolbar-title>
</template>

<script>
import { mapState } from "vuex";

export default {
  name: "DashboardView",
  data() {
    return {
      currentPageTitle: '',
      specialTitles: {
        'trading-account': 'Trading Account',
        'deposit': 'Deposit',
        'withdraw': 'Withdraw',
        'transaction-history': 'Transaction History',
        'profile': 'Profile Settings'
      },
      tabTitles: {
        '1': 'Overview',
        '2': 'Documents',
        '3': 'Trading Accounts',
        '4': 'Transactions'
      }
    };
  },
  computed: {
    ...mapState("profile", ["client"]),
    isDashboard() {
      return this.$route.path === '/dashboard';
    },
    displayName() {
      const name = `${this.client?.fname || ""} ${this.client?.lname || ""}`.trim();
      return name || this.client?.company_name || "Trader";
    },
  },
  
  methods: {
    updatePageTitle() {
      if (!this.isDashboard) {
        const path = this.$route.path.split('/').pop();
        const queryParams = this.$route.query;
        this.currentPageTitle = this.getPageTitle(path, queryParams);
      }
    },
    getPageTitle(path, queryParams) {
      // Check if we have a tab parameter
      if (queryParams.tab && this.tabTitles[queryParams.tab]) {
        return `${this.specialTitles[path] || this.formatPageTitle(path)}`;
      }

      // If no tab parameter or unknown tab, use the special title or format the path
      return this.specialTitles[path] || this.formatPageTitle(path);
    },
    formatPageTitle(title) {
      // Handle kebab-case (e.g., "trading-account")
      if (title.includes('-')) {
        return title.split('-')
          .map(word => word.charAt(0).toUpperCase() + word.slice(1))
          .join(' ');
      }

      // Handle camelCase or PascalCase (e.g., "tradingAccount")
      return title.replace(/([A-Z])/g, ' $1')
        .trim()
        .split(' ')
        .map(word => word.charAt(0).toUpperCase() + word.slice(1))
        .join(' ');
    },
  },
  async mounted() {
    try {
      this.updatePageTitle();
    } catch (error) {
      console.error("Error fetching profile:", error);
    }
  },
  watch: {
    $route() {
      this.updatePageTitle();
    },
  },
};
</script>

<style scoped>
.dashboard-greeting {
  display: flex;
  flex-direction: column;
  line-height: 1.2;
}

.dashboard-toolbar-title {
  margin-left: 240px !important;
  padding-left: 18px !important;
}

.dashboard-greeting strong {
  font-size: 18px;
  font-weight: 700;
}

.dashboard-greeting small {
  margin-top: 5px;
  color: #9da7b4;
  font-size: 10px;
  font-weight: 400;
}

@media (max-width: 959.98px) {
  .dashboard-toolbar-title {
    margin-left: 0 !important;
    padding-left: 0 !important;
  }
}

@media (max-width: 599.98px) {
  .dashboard-greeting strong {
    font-size: 14px;
  }

  .dashboard-greeting small {
    display: none;
  }
}
</style>
